// The one hardcoded allowlist that remains by design: a lockout-safety fallback so
// the dynamic access-control admin page itself can never be locked out of. Mirrors
// SUPER_ADMIN_UPNS in the backend's .env — keep both in sync if this ever changes.
export const SUPER_ADMIN_UPNS: string[] = [
  'pulfers@landpoint.net',
  'pturner@landpoint.net'
];
